import { UsersAPI } from '../../lib/api';
import { auth } from '../../lib/auth';
import { normalizeError } from '../../lib/helpers';

export const ADD_ERROR = 'SETTINGS.ADD_ERROR';
export const CLEAR_ERROR = 'SETTINGS.CLEAR_ERROR';
export const RECEIVE_SETTINGS = 'SETTINGS.RECEIVE_SETTINGS';
export const RECEIVE_USER = 'SETTINGS.RECEIVE_USER';


const API = {
  users: new UsersAPI(),
};


export const receiveSettings = settings => ({
  type: RECEIVE_SETTINGS,
  settings,
});


export const addError = error => ({
  type: ADD_ERROR,
  error: normalizeError(error),
});


export const clearError = () => ({
  type: CLEAR_ERROR,
});


export const receiveUser = user => ({
  type: RECEIVE_USER,
  user,
});


export const updateUser = (orgId, user) => (dispatch) => {
  const personId = auth.person_id;

  API.users.update(orgId, personId, user)
    .then(() => dispatch(receiveUser(user)))
    .catch((err) => {
      console.log('Error: ', err);
      dispatch(addError(err));
    });
};



// WEBPACK FOOTER //
// ./src/redux/actions/Settings.js